import { EditableItemDynamicTab } from "../../../components/dynamicEditor/dynamicTab/editableItem";
import { useRepContext } from "../../../contexts/editableItemContext";
import { tabs } from "../../../string";
import style from "./style.module.scss";

export function AgentSummary() {
	const context = useRepContext();

	return (
		<EditableItemDynamicTab
			itemContext={context}
			pageName={tabs.agentSummary}
			itemProp="rep"
			updateValues={null}
			save={undefined}
			readonly
			loaded={context.repLoaded}
			containerClass={style.detailsContainer}
		/>
	);
}
